<div class="layout-menu-wrapper" [ngClass]="{'layout-menu-wrapper-active': app.menuActive}" (click)="app.onMenuClick()">
    <div class="layout-menu-container">
        <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of menu; let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
    </div>
</div>
